import {keys, pick} from 'underscore'

/**
 * @mixin
 */
const PROPS = {
    /**
     * Set this to remove padding
     */
    dense: {
        type: Boolean,
        default: false
    },
    /**
     * Font size - See Typography mixin for options
     */
    fontSize: {
        type: String,
        default: 'subheading'
    },
    /**
     * Font weight - See Typography mixin for options
     */
    fontWeight: {
        type: String,
        default: 'medium'
    },
    /**
     * Description - The text to be displayed
     */
    description: {
        type: String,
        default: ''
    }
}

/**
 * @mixin
 */
export default {
    props: PROPS,
    computed: {
        wDescriptionProps () {
            const vm = this
            const propKeys = keys(PROPS)

            return pick(vm, propKeys)
        }
    }
}
